import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {TOUR_STEPS} from './apptourdata';

export function AppTour({ open, onClose, setSidebarOpen }) {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!open) setStep(0);
  }, [open]);

  React.useEffect(() => {
    if (open && TOUR_STEPS[step] && TOUR_STEPS[step].navTo) {
      navigate(TOUR_STEPS[step].navTo);
    }
    if (open && TOUR_STEPS[step] && TOUR_STEPS[step].openSideBar !== undefined) {
      setSidebarOpen(TOUR_STEPS[step].openSideBar);
    }
    // eslint-disable-next-line
  }, [step, open]);

  if (!open) return null;

  const current = TOUR_STEPS[step];
  let highlightStyle = {};
  if (current.target) {
    const el = document.querySelector(current.target);
    if (el) {
      const rect = el.getBoundingClientRect();
      highlightStyle = {
        position: 'fixed',
        top: rect.top - 0,
        left: rect.left - 0,
        width: rect.width + 0,
        height: rect.height + 0,
        border: '5px solid #deb841',
        borderRadius: 8,
        pointerEvents: 'none',
        zIndex: 6003,
        boxShadow: '0 0 0 9999px rgba(0,0,0,0.8)'
      };
    }
  }

  return (
    <>
      {current.target && <div style={highlightStyle}></div>}
      <div style={{
        position: 'fixed',
        top: '40%',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'rgba(255,255,255,0.95)',
        borderRadius: 12,
        boxShadow: '0 4px 32px rgba(0,0,0,0.18)',
        padding: '2rem',
        zIndex: 6004,
        minWidth: 320,
        maxWidth: 400,
        textAlign: 'center'
      }}>
        <h2 style={{color: '#2e275a'}}>{current.title}</h2>
        <p style={{margin: '1rem 0'}}>{current.content}</p>
        <div style={{marginTop: 24}}>
          {step > 0 && <button onClick={() => setStep(s => s - 1)} style={{marginRight: 12}}>Back</button>}
          {step < TOUR_STEPS.length - 1 && <button onClick={() => setStep(s => s + 1)} style={{background: '#deb841', color: '#222', fontWeight: 'bold', border: 0, borderRadius: 6, padding: '0.5rem 1.5rem'}}>Next</button>}
          {step === TOUR_STEPS.length - 1 && <button onClick={onClose} style={{background: '#2e275a', color: 'white', fontWeight: 'bold', border: 0, borderRadius: 6, padding: '0.5rem 1.5rem'}}>Finish</button>}
        </div>
        <button onClick={onClose} style={{position: 'absolute', top: 10, right: 16, background: 'transparent', border: 0, fontSize: 22, color: '#888', cursor: 'pointer'}}>×</button>
      </div>
    </>
  );
}